<template lang="pug">
  include /mixins
  +b.ds-panel--space_lg.--space_sm-xl
    +e.element--offset_horizontal
      template(v-for='val in sortedList')
        +b.tt-space_mt--3
          +b.d-control-input.--appearance_flexible(
            v-if='!val.hasOwnProperty("is_valid") || val.is_valid'
          )
            +e.element.INPUT(
              type='checkbox'
              :value='val.props.label',
              :name='filter.attribute.label'
              :key='`input_${val.props.label}`'
              v-model='checked'
              :input-label='val.props.title',
              :id='`${filter.attribute.label}:${val.id}`'
              :disabled='!val.is_available'
              @change='submit()'
            )
            +e.LABEL.label--for-checkbox(
              :for='`${filter.attribute.label}:${val.id}`'
            )
              tag.fake-link(
                :key='`tag_${val.props.label}`'
                :tag='url(val.props.label, val.props.id) ? "a" : "span"'
                :href='url(val.props.label, val.props.id)'
              ) {{ val.props.title }}
              //- #[b(style='font-size: 10px') {{ url(val.props.label, val.id) }}]
            // for available filters debug
            //- span(style='color: red') {{ !!isAvailable(val.id, val.props.label) }}
</template>
<script>
import urlGeneratorMixin from './urlGenerator'

export default {
  name: 'CheckboxRenderer',
  props: ['value', 'filter', 'available', 'all', 'baseUrl', 'isDynamic'],
  mixins: [urlGeneratorMixin],
  data() {
    return {
      checked: [],
    }
  },
  computed: {
    sortedList() {
      this.filter.attribute.values.forEach((el, i) => {
        this.$set(this.filter.attribute.values[i], 'is_available', !!this.isAvailable(el.id, el.props.label))
      })
      let list = []
      list = this.filter.attribute.values
        .sort((a, b) => this.isDynamic ? a.props.title.localeCompare(b.props.title) : true)
        .sort((a, b) => b.is_available - a.is_available)
      return list
    },
    hideAll() {
      return this.sortedList.every(item => !item.is_available)
    },
  },
  watch: {
    value(nval) {
      this.checked = this.normalize(nval)
    },
    hideAll: {
      handler() {
        this.$emit('hide', { key: this.filter.attribute.label, value: this.hideAll })
      },
      immediate: true,
    },
  },
  mounted() {
    this.checked = this.normalize(this.value)
  },
  methods: {
    submit() {
      this.$emit('input', this.checked)
    },
    isAvailable(id, label) {
      if (!this.available.attributes) return true
      const customFilter = this.available[this.filter.attribute.label]
      if (customFilter) {
        const a = customFilter.find(el => el == id)
        if (!a && this.hasActive(label)) return true
        return a
      }
      const a = this.available.attributes.find(el => el == id)
      if (!a && this.hasActive(label)) return true
      return a
    },
    hasActive(val) {
      return this.checked.includes(val)
    },
    normalize(value) {
      if (!value) return []
      const checked = this.filter.attribute.values.filter(el => value.find(v => v == el.props.label)).map(el => el.props.label)
      return checked
    },
  },
}
</script>
